import { createModelStore } from '@/shared/stores/create-model-store'
import { model2_3InitialModel } from './initial-state'
import { model2_3DimensionHandlers } from './dimensions'

export const useModel2_3Store = createModelStore({
  initialModel: model2_3InitialModel,
  dimensionHandlers: model2_3DimensionHandlers,
})
